// eslint-disable-next-line prefer-destructuring
const isProd = process.env.NODE_ENV === 'production';
const uniqueIdentitier = process.env.APP_COMMIT_ID;

const getPlannerWorker = () => {
  if (isProd) {
    const location = `/_next/static/chunks/planner-main-v2.web-worker.${uniqueIdentitier}.js`;
    const name = `planner-main-v2.web-worker.${uniqueIdentitier}`;
    return new Worker(new URL(location, window.location.href), { name });
  }
  return new Worker(
    new URL('../workers/main/planner.worker.js', import.meta.url),
    {
      name: 'planner-main-v2.web-worker' // source
    }
  );
};

export default getPlannerWorker;
